
























import {Component, Vue, Watch} from 'vue-property-decorator';
import CSelect from '@/components/base/select/CSelect.vue';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import AIEnum from '@/enums/AIEnum';
@Component({
    components: {CDatepicker, CFlexGrid, CSelect},
})
export default class WarehousePlywoodState extends Vue {
    private warehouseId: number | null = null;
    private datetime = Date.now();

    private aiEnum = AIEnum;
    private updateBtnDisabled = true;

    get flexQuery() {
        return {
            date: this.datetime,
            IdWarehousePlywood: this.warehouseId,
        };
    }

    @Watch('datetime')
    onDateTimeChange(value: number, oldValue: number) {
        if (value !== oldValue) this.updateBtnDisabled = false;
    }

    @Watch('warehouseId')
    onWarehouseIdChange(value: number | null, oldValue: number | null) {
        if (value !== oldValue) this.updateBtnDisabled = false;
    }

    created() {
        let date = new Date(Date.now());
        date.setSeconds(0);
        date.setMilliseconds(0);
        this.datetime = Date.parse(date.toISOString());
    }

    update() {
        let fg = this.$refs.fg as any;
        fg.getData();
        this.updateBtnDisabled = true;
    }
}
